

import _ from 'lodash';
import moment from 'moment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HistoryIcon from '@material-ui/icons/History';
import UpdateIcon from '@material-ui/icons/Update';
import { Cookies } from 'react-cookie';
import {
  ORDER_PHASE_CONTACTING,
  ORDER_HISTORY,
  ORDER_FUTURE,
  ALL_ORDERS,
  ALL_ORDER_TYPES, ORDER_TYPE_DELIVERY, ORDER_TYPE_COLLECT, SUITABLE_ORDER_TYPES, ORDER_FLOW_TYPE, ERROR_ACCEPT_DELIVEROO_CGU, ERROR_UPDATE_SHOPS_DELIVEROO_CGU,
  DISPLAY_REOPEN_SHOP_MODAL_INTERVAL, DELIVEROO, PROXIMITY_RADIUS_KM,
  DRIVER_ONLINE
} from '../../constants';
import {
  getOrdersWithStatus,
  getOrderStatusLabel,
  getEstimationTime
} from '../../utils/orderUtils';
import { getClosedDrivers } from '../../utils/mapUtils';
import { showNotification } from '../../components/Notification/Notification.view';
import cancelOrderSong from '../../assets/sounds/cancelOrderSong.mp3';
import sound from '../../assets/sounds/orderSong.mp3';
import emergencyDeliverySong from '../../assets/sounds/emergencyDeliverySong.mp3';
import { getCanceledOrder, updateShopsDeliverooCgu } from '../../apis/backend';
import { onChangeClosedShop } from '../../components/Sidebar/Sidebar.services';
import proximitySound from '../../assets/sounds/proximitySound.mp3';
import { getDistanceFromLatLonInKm } from '../../utils/mapUtils';
import { updateDeliveryReminderTriggered } from '../../apis/backend';
import { diffInMinutesExact } from '../../utils/suitableDate';
import { getDriverDistanceKmMax } from 'src/utils/delivery';
const cookies = new Cookies();

let setIntervalTime = '';
let setIntervalSong = null;
let newOrderSound = null;
let cancelOrderSound = null;
let emergencyDeliverySound = null
let setIntervalEmergencySong = null;
let nbSong = 0;
let nbEmergencySong = 0;
const DUREE_MIN_SONG = 0.4;
const DURATION_INTERVAL_SONG = DUREE_MIN_SONG * 60 * 1000;
let interval = null;
let audio = null;
let playCount = 0;
let isModalOpen = false;
const modalQueue = [];
const MAX_PLAYS = 6;
const INTERVAL_MS = 7000;

export const getOrdersShopId = (orders, shopId, isAllShops) => {
  const ordersByShopId = [];
  _.map(orders, order => {
    _.map(order, o => {
      if (isAllShops) ordersByShopId.push(o);
      else if (o.shopId === shopId) {
        ordersByShopId.push(o);
      }
    });
  });
  return ordersByShopId;
};

export const getDrivers = async (props, component) => {
  const { location = {}, independentDrivers = [], drivers: driverEmployees = [], shopId } = props;
  const driverDistanceKmMax = getDriverDistanceKmMax();
  const closeIndependentDrivers = getClosedDrivers(independentDrivers, location, driverDistanceKmMax);
  const closeDrivers = getClosedDrivers(driverEmployees, location, driverDistanceKmMax);
  const drivers = closeDrivers.concat(closeIndependentDrivers);
  let nbDriversAvailable = 0;
  let nbDriversFreelance = 0;
  drivers &&
    drivers.forEach(driver => {
      const { isFreelance, shopIds = {}, status, tokenNotifications, freelance } = driver;
      const { enabled: enabledShop = isFreelance } = shopIds[shopId] || {};
      let enabled = enabledShop;
      if (isFreelance && !shopIds[shopId]) {
        enabled = true;
      }
      const hasToken = !!tokenNotifications;
      const isFreelanceVerified = !isFreelance || !!freelance?.verification;
      const isOnlineAndClose = status === DRIVER_ONLINE;
      const isAvailable = enabled && hasToken && isFreelanceVerified && isOnlineAndClose;
      if (isAvailable) {
        nbDriversFreelance = isFreelance ? nbDriversFreelance + 1 : nbDriversFreelance;
        nbDriversAvailable = !isFreelance ? nbDriversAvailable + 1 : nbDriversAvailable;
      }
    });
  component.setState({ driversAvailability: { nbDriversAvailable, nbDriversFreelance } });
};

export const updateTime = component => {
  setIntervalTime = setInterval(() => {
    component.setState({
      currentDate: moment().seconds(moment().seconds() + 1)
    });
  }, 1000);
};
export const clearIntervalTime = () => {
  clearInterval(setIntervalTime);
};
export const handleLoadAudio = (component) => {
  const { orders, shopId, showModal, isAllShops } = component.props;
  const loadSound = (soundFile) => {
    const audio = new Audio(soundFile);
    audio.load();
    return audio;
  };
  newOrderSound = loadSound(sound);
  cancelOrderSound = loadSound(cancelOrderSong);
  emergencyDeliverySound = loadSound(emergencyDeliverySong);
  const currentOrdersPhaseContacting = getOrdersWithStatus(
    getOrdersShopId(orders, shopId, isAllShops),
    ORDER_PHASE_CONTACTING
  );
  if (currentOrdersPhaseContacting.length > 0) {
    clearIntervalSong(true);
    clearIntervalSong();
    getOrdersSound(currentOrdersPhaseContacting);
  }
  showModal(null);
};


const play = async (sound, nb, isEmergency) => {
  if (sound) {
    try {
      if (nb > 5) {
        clearIntervalSong(isEmergency);
        nb = 0;
      } else {
        nb++;
      }

      await sound.play();


    } catch (err) {
      console.err(`Error playing audio: ${err}`);
    }
  }
};

export const launchIntervalSong = (isEmergencyDelivery) => {
  const soundToPlay = isEmergencyDelivery ? emergencyDeliverySound : newOrderSound;
  try {
    if (soundToPlay) {
      soundToPlay.play();
      isEmergencyDelivery ? nbEmergencySong = 0 : nbSong = 0;
      isEmergencyDelivery ? setIntervalEmergencySong = setInterval(() => play(soundToPlay, nbEmergencySong, true), DURATION_INTERVAL_SONG) : setIntervalSong = setInterval(() => play(soundToPlay, nbSong), DURATION_INTERVAL_SONG);
    }

  } catch (error) {
    console.err(`Error in launchIntervalSong - play audio error: ${error}`);
  }
};

export const clearIntervalSong = (isEmergency) => {
  isEmergency ? clearInterval(setIntervalEmergencySong) : clearInterval(setIntervalSong);


};

export const handleCompositionOrders = async (component, nextState, props) => {
  const { orderTypeSelected, selectedToType, selectedType } = nextState;
  const type = selectedToType[orderTypeSelected];
  const { shopId, orders: pendingOrders = {}, finishedOrders, isAllShops } = props;
  const orderTypes = ALL_ORDER_TYPES;
  const selectedOrderType =
    shopId !== component.props.shopId || !orderTypes.includes(selectedType)
      ? ALL_ORDERS
      : selectedType;
  component.setState({
    isLoading: true,
    isGrid: JSON.parse(new Cookies().get('isGrid') || true),
    orderTypeSelected: shopId !== component.props.shopId ? 0 : orderTypeSelected,
    selectedType: selectedOrderType
  });
  const newOrders = getOrdersShopId(pendingOrders, shopId, isAllShops)

  setCloche(newOrders, component);
  if (type === ORDER_HISTORY) {
    if (finishedOrders) {
      const orders = getOrdersByOrderType(sortOrders(finishedOrders, type), orderTypes, props);

      component.setState({
        orders,
        viewedOrders: orders[selectedOrderType],
        isLoading: false
      });
    }
  } else {
    const orders = getOrdersByOrderType(
      sortOrders(filterOrders(pendingOrders, shopId, type === ORDER_FUTURE, isAllShops)),
      orderTypes,
      props
    );
    const currentOrders = getOrdersByOrderType(
      sortOrders(filterOrders(pendingOrders, shopId, false, isAllShops)),
      orderTypes,
      props
    );
    const oldOrders = getOrdersShopId(component.props.orders, shopId, isAllShops)
    component.setState({
      orders,
      viewedOrders: orders[selectedOrderType],
      isLoading: false,
      currentOrders
    });
    if (_.size(newOrders) < _.size(oldOrders) && selectedToType[component.state.orderTypeSelected] !== ORDER_HISTORY) {
      const missingOrders = _.filter(
        oldOrders,
        order => !_.find(newOrders, { chargeId: order.chargeId })
      )
      for (const order of missingOrders) {
        const { chargeId, id, orderNumber, orderType, totalProductPriceOrder, shop } = order;
        const canceledOrder = await getCanceledOrder(id, chargeId);
        if (canceledOrder?.cancellation?.canceledBy === 'customer') {
          cancelOrderSound.play();
          const alertMessage = `La commande ${orderType === ORDER_TYPE_DELIVERY ? 'en' : orderType === ORDER_TYPE_COLLECT ? 'à' : ''} 
          <strong> ${SUITABLE_ORDER_TYPES[orderType].toLowerCase()} </strong> numéro <strong>${orderNumber}</strong> d’un montant de ${totalProductPriceOrder} € a été annulée par le client  ${isAllShops ? `pour le shop  ${shop?.name} .` : '.'}`;
          showNotification(
            'light',
            'ltr',
            'danger',
            'Commande annulée',
            alertMessage,
            '',
            'true'
          );
        }
      }
    }


  }
};

const setCloche = (orders, component) => {
  const { selectedToType = [] } = component.state;
  selectedToType.forEach(type => {
    const nextOrdersPhaseContactingByType = getOrdersWithStatus(
      orders,
      ORDER_PHASE_CONTACTING,
      type
    );
    if (nextOrdersPhaseContactingByType.length > 0) {
      component.setState({ [type]: true });
    } else {
      component.setState({ [type]: false });
    }
  });
};

const getOrdersByOrderType = (orders, types, props) => {
  const { isAllShops, shops } = props;
  const filredOrdersByShopId = isAllShops
    ? _.filter(orders, elt => _.keys(shops).includes(elt.shopId))
    : orders;
  let data = { allOrders: filredOrdersByShopId };
  types.forEach(type => {
    const filtredOrders = _.filter(filredOrdersByShopId, order => order.orderType === type);
    data = { ...data, [type]: filtredOrders };
  });
  return data;
};

export const sortOrders = (orders, type) => {
  return _.orderBy(
    orders,
    [
      order => {
        return moment(order.date);
      },
      'orderNumber'
    ],
    [type === ORDER_HISTORY ? 'desc' : 'asc', 'desc']
  );
};

export const filterOrders = (listOrders, shopid, isFutureOrder, isAllShops) => {
  const ordersFiltered = [];

  _.map(listOrders, orders => {
    _.map(orders, order => {
      const {
        shopId,
        status,
        cancellation = {},
        date,
        datePreparationStarted = moment().format(),
      } = order;
      const currentDate = isFutureOrder
        ? moment().isBefore(moment(date).subtract(6, 'hours'), 'day')
        : moment().isSameOrAfter(moment(date).subtract(6, 'hours'), 'day');
      const initialOrderDate = date
      if ((shopId === shopid || isAllShops) && currentDate) {
        const { cancelReason } = cancellation;
        order.statusLabel = getOrderStatusLabel(status, cancelReason, status);
        ordersFiltered.push({
          ...order,
          datePreparationStarted,
          initialOrderDate
        });
      }
    });
  });
  return ordersFiltered;
};

export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, (e, index) => {
    newData.push({
      label: e,
      icon: index === 0 ? <AccessTimeIcon /> : index === 1 ? <UpdateIcon /> : <HistoryIcon />
    });
  });
  return newData;
};
export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-5 col-md-5 col-lg-2';
  if (numberOfItems > 2) {
    classNameBottomNavigation = 'col-sm-12 col-md-7 col-lg-6 col-xl-4';
  }
  return classNameBottomNavigation;
};
export const onChangeData = async (e, value, rowsPerPage, component) => {
  const { shopId, isAllShops } = component.props;
  const { dateRange } = component.state;
  component.props.initPage(rowsPerPage);
  component.setState({ orderTypeSelected: value });
  if (value === 2) await component.props.getFinishedOrders(isAllShops ? null : shopId, dateRange);
};
export const handleClick = ({ order }, component) => {
  component.setState({ modalOpen: true, order });
};

export const handleClose = component => {
  component.setState({ modalOpen: false });
};
export const onChangeLayout = (value, component) => {
  cookies.set('isGrid', value);
  component.setState({ isGrid: value });
};

export const onSelectDate = (component, dateRange) => {
  const { shopId, isAllShops } = component.props;
  component.setState({ dateRange });
  component.props.getFinishedOrders(isAllShops ? null : shopId, dateRange, true);
};

export const getOrdersSound = (currentOrdersPhaseContacting) => {
  const ordersPhaseContacting = getOrdersPhaseContactingInReverseFlow(currentOrdersPhaseContacting)
  const orderPhaseSearchingDrivers = getFirstOrderPhase(currentOrdersPhaseContacting);
  if (ordersPhaseContacting.length > 0) {
    launchIntervalSong();
  }
  else {
    clearIntervalSong()
  }
  if (orderPhaseSearchingDrivers.length > 0) {
    launchIntervalSong(true);
  }
  else {
    clearIntervalSong(true)
  }
};
export const getFirstOrderPhase = (orders) => {
  return _.filter(orders, order => order.pickupStatus === 0 && order.orderFlowType === ORDER_FLOW_TYPE.REVERSE && order.selfPickupEligible && order.orderType === ORDER_TYPE_DELIVERY)
}
export const getOrdersPhaseContactingInReverseFlow = (currentOrdersPhaseContacting) => {
  const ordersPhaseContacting = _.filter(currentOrdersPhaseContacting, order => (order.pickupStatus === 0 && (order.orderFlowType !== ORDER_FLOW_TYPE.REVERSE || order?.orderType !== ORDER_TYPE_DELIVERY)) || (order.pickupStatus === 1 && order.orderFlowType === ORDER_FLOW_TYPE.REVERSE));
  return ordersPhaseContacting
}
export const handleAcceptDeliveryCgu = async (component, showModal) => {
  const { deliverooInfo } = component.state
  if (deliverooInfo) {
    try {
      await updateShopsDeliverooCgu();
    } catch {
      component.props.openErrorModal(ERROR_UPDATE_SHOPS_DELIVEROO_CGU)
    }
    showModal(null)
    component.setState({ showAcceptConditionsModal: false, showDeliverooInfo: false, deliverooInfo: false })
  }
  else component.props.openErrorModal(ERROR_ACCEPT_DELIVEROO_CGU)
}
export const closeAcceptConditionsModal = (component) => {
  const { showModal } = component.props;
  component.setState({ showAcceptConditionsModal: false });
  showModal(null)
};
export const closeDeliverooInfo = (component) => {
  component.setState({ showDeliverooInfo: false });
};
export const setupReopenModalInterval = (component) => {
  const { closed } = component.props
  clearReopenModalInterval(component);

  const interval = setInterval(() => {
    if (closed) {
      showReopenModal(component);
    }
  }, DISPLAY_REOPEN_SHOP_MODAL_INTERVAL);

  component.setState({ reopenModalInterval: interval });
};
export const clearReopenModalInterval = (component) => {
  const { reopenModalInterval } = component.state
  if (reopenModalInterval) {
    clearInterval(reopenModalInterval);
    component.setState({ reopenModalInterval: null });
  }
};
export const showReopenModal = (component) => {
  const now = moment();
  const { lastClosedModalShownAt, isFirstLoad } = component.state;
  if (isFirstLoad || !lastClosedModalShownAt || now.diff(lastClosedModalShownAt, 'minutes') >= DISPLAY_REOPEN_SHOP_MODAL_INTERVAL) {
    component.setState({
      lastClosedModalShownAt: now,
      isFirstLoad: true
    });
    renderReopenShopModal(component);
  }
};
export const renderReopenShopModal = (component) => {
  const { showModal, closed } = component.props;
  const modalData = {
    color: 'danger',
    btnTxt: 'Ouvrir le magasin',
    btnCloseTxt: 'Rester fermé',
    showCancelBtn: true,
    message: <p style={{ color: '#ff4861' }}>Votre magasin est actuellement fermé, vous ne pouvez pas recevoir de commande</p>,
    handleClose: () => {
      showModal(null);
      setupReopenModalInterval(component);
    },
    onClick: () => {
      onChangeClosedShop(closed)
      showModal(null);

    },
  };

  if (showModal) {
    showModal(modalData);
  }

}

export const displayClosedShopModal = (component) => {
  if (component.props.closed) {
    component.setState({ isFirstLoad: true }, () => {
      showReopenModal(component);
      setupReopenModalInterval(component);
    });
  }
}







export const clearDeliveryAlert = () => {
  if (interval) {
    clearInterval(interval);
    interval = null;
  }
  if (audio) {
    audio.pause();
    audio.currentTime = 0;
    audio = null;
  }
  playCount = 0;
};

const playSound = async () => {
  if (!audio) return;
  if (!audio.paused) return;
  try {
    await audio.play();
  } catch (err) {
    console.error('Erreur lecture audio:', err);
  }
};

export const handleCloseModal = (component) => {
  clearDeliveryAlert();
  if (audio) {
    audio.pause();
    audio.currentTime = 0;
    audio = null;
    playCount = 0;
  }

  component.props.showModal(null);
  isModalOpen = false;

  if (modalQueue.length > 0) {
    const next = modalQueue.shift();
    launchDeliveryAlert(next.order, next.component);
  } else {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }
};

const launchDeliveryAlert = async (order, component) => {
  if (order.deliveryReminderTriggered) return;
  if (isModalOpen) {
    const exists = modalQueue.some(item => item.order.id === order.id);
    if (!exists) {
      modalQueue.push({ order, component });
    }
    return;
  }

  isModalOpen = true;
  audio = new Audio(proximitySound);
  playCount = 0;

  component.props.showModal({
    color: 'danger',
    title: `Commande #${order.orderNumber}`,
    description: 'Livreur à proximité',
    message:
      'Votre livreur est à 5 minutes de votre restaurant, assurez-vous d’avoir bien préparé la commande.',
    btnTxt: 'Confirmer',
    header: true,
    width: 450,
    btnColor: 'danger',
    onClick: () => handleCloseModal(component),
    handleClose: () => handleCloseModal(component),
  });

  playSound();

  if (!order.deliveryReminderTriggered) {
    try {
      await updateDeliveryReminderTriggered(order.id, order.chargeId);
    } catch (err) {
      console.error('Erreur updateDeliveryReminderTriggered', err);
    }
  }

  playCount++;
  interval = setInterval(() => {
    if (playCount >= MAX_PLAYS) {
      handleCloseModal(component);
    } else {
      playSound();
      playCount++;
    }
  }, INTERVAL_MS);
};




export const checkDeliveryProximity = async (externalDrivers, component) => {
  const { shopId } = component.props;
  const { currentOrders } = component.state;

  if (
    !currentOrders.allOrders ||
    _.size(currentOrders.allOrders) === 0 ||
    component.props.isAllShops
  )
    return;

  _.forEach(currentOrders.allOrders, async (order) => {
    const isDeliveroo =
      order?.delivery?.nature?.toUpperCase() === DELIVEROO &&
      order.orderType === ORDER_TYPE_DELIVERY &&
      !order?.shopResponsibleForDelivery &&
      order.shopId === shopId;

    if (!isDeliveroo) return;

    const { latitude, longitude } = order?.shop?.address?.location;
    const driverId = order?.idDep;
    if (!latitude || !longitude || !driverId) return;

    const driver = _.find(externalDrivers, (driver) => driver.driverId === driverId);
    if (!driver || !driver.lat || !driver.long) return;

    const { expectedPickupDate } = order;
    if (expectedPickupDate) {
      const diff = diffInMinutesExact(expectedPickupDate, moment());
      if (diff <= 8 && diff > 0 && !order.deliveryReminderTriggered) {
        await launchDeliveryAlert(order, component);
      }

      return;
    }


    let distanceKm = getDistanceFromLatLonInKm(latitude, longitude, driver.lat, driver.long);
    distanceKm = Math.round(distanceKm * 100) / 100;

    if (distanceKm <= PROXIMITY_RADIUS_KM && !order.deliveryReminderTriggered) {
      await launchDeliveryAlert(order, component);
    }
  });
};




